import { ReactNode } from 'react';

type PlayGroundCardType = {
  header: string;
  amount: string;
  description: string;
  icon: ReactNode;
};

type PlayGroundCardProps = {
  item: PlayGroundCardType;
};

export default function PlayGroundCard({ item }: PlayGroundCardProps) {
  return (
    <div
      style={{
        width: 314,
        //   height: 143,
        borderRadius: 20,
        padding: 20,
        border: '1px solid var(--analytics_grey)'
      }}>
      <div className="d-flex justify-content-between">
        <div>
          <p className="m-0 h6 w400">{item?.header}</p>
          <p className="h2_32 m-0 un_standard_color w600">{item?.amount}</p>
        </div>
        {item?.icon}
      </div>
      <div>
        <p className="m-0 h5_400" style={{ color: 'var(--grey_tone)' }}>
          {item?.description}
        </p>
      </div>
    </div>
  );
}
